export default "__VITE_ASSET__b79db173__"